import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgExternalLink = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.077 2C2.482 2 2 2.482 2 3.077v9.846C2 13.518 2.482 14 3.077 14h9.846c.595 0 1.077-.482 1.077-1.077v-2.308h-.923v2.308a.154.154 0 0 1-.154.154H3.077a.154.154 0 0 1-.154-.154V3.077c0-.085.069-.154.154-.154h2.308V2H3.077Zm9.21 1.068L6.57 8.785l.65.65 5.717-5.717-.002 4.09h.92l.002-5.66-5.66.002v.92l4.09-.002Z",
    fill: "#511E62"
  })
}));
export default SvgExternalLink;